// Frontend mirror of scripts/lib/blog-sections.js: the section registry the
// React UI reads. A section = one GHL blog surfaced on frayze.ca at a route
// prefix. `localFeed` is the prerendered feed the site serves; `externalFeed`
// is the GHL fallback used for client-side freshness when the local one 404s.
//
// Keep blogIds in sync with scripts/lib/blog-sections.js.

export type BlogSection = {
  key: "blog" | "updates";
  basePath: string; // "/blog" | "/updates"
  label: string; // breadcrumb + heading label
  localFeed: string;
  externalFeed: string;
};

const feed = (blogId: string) =>
  `https://rss-link.com/feed/9A5cW9ju0zoGXbGIDmyW?blogId=${blogId}&limit=50&loadContent=true`;

export const BLOG_SECTION: BlogSection = {
  key: "blog",
  basePath: "/blog",
  label: "Blog",
  localFeed: "/blog/rss.xml",
  externalFeed: feed("522uUS6Nh4j3KfRnXCVd"), // Frayze Articles
};

export const UPDATES_SECTION: BlogSection = {
  key: "updates",
  basePath: "/updates",
  label: "What's New",
  localFeed: "/updates/rss.xml",
  externalFeed: feed("xR0NhrYGcmuUU2dWQLaG"), // Frayze Product Updates
};
